import { useConcept } from '../../../redux/selectConcept'
import L3Markdown from '../l3/L3Markdown'

interface L4MarkdownProps {
	cid?: string
	content?: string
}

const L4Markdown = ({cid, content}: L4MarkdownProps) => {
	const concept = useConcept(cid)
	return <L3Markdown concept={concept ?? undefined} content={content} />
}

export default L4Markdown
